var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileNavbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.92 7.33003V14.17C18.92 15.29 18.32 16.33 17.35 16.9L11.41 20.33C10.44 20.89 9.24004 20.89 8.26004 20.33L2.32 16.9C1.35 16.34 0.75 15.3 0.75 14.17V7.33003C0.75 6.21003 1.35 5.16999 2.32 4.59999L8.26004 1.17C9.23004 0.61 10.43 0.61 11.41 1.17L17.35 4.59999C18.32 5.16999 18.92 6.20003 18.92 7.33003Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83975 9.7498C11.1265 9.7498 12.1697 8.70662 12.1697 7.4198C12.1697 6.13298 11.1265 5.08984 9.83975 5.08984C8.55295 5.08984 7.50977 6.13298 7.50977 7.4198C7.50977 8.70662 8.55295 9.7498 9.83975 9.7498Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8398 15.4094C13.8398 13.6094 12.0498 12.1494 9.83984 12.1494C7.62984 12.1494 5.83984 13.6094 5.83984 15.4094",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNavbar);
export default __webpack_public_path__ + "static/media/profile_navbar.d8f5ef7912b41dc00b4516465e285ae7.svg";
export { ForwardRef as ReactComponent };